import React, { useEffect, useRef, useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import DynamicForm from "../offer/cif/DynamicForm";
import {  buyerWithAgentRole } from "../offer/cif/formFields";
import { verifyLicense } from "@/api/placeOffer";
import { formatDisplayDate } from "@/utils/dateFormatter";
import { validateAddress } from "@/api/bid";

const EditBuyersAgent = ({
  state,
  setAccordionState,
  accordionState,
  editCifData,
  setEditCifData,
  validateEmail,
  propertyId,
  formState
}) => {  
  const [haveErrors, setHaveErrors] = useState(false);
  const [buyerAgentDetails, setBuyerAgentDetails] = useState({});
  const validationFnRef = useRef({});
  const [error, setError] = useState({});
  const [isAgent, setIsAgent] = useState("false");
  const [externalFormErrors, setExternalFormErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setIsAgent(e.target.value);
  };
  const convertToUIDate = (dateString) => {
  try {
    if (typeof dateString !== "string") return "";
    const parts = dateString.split("/");
    if (parts.length === 3) {
      const [month, day, year] = parts;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return "";
  } catch (error) {
    console.error("Invalid date format:", error);
    return "";
  }
};

  const licenseVerification = async () => {
    try {
      const payload = {
        licenceNumber: buyerAgentDetails?.individualLicenseNumber,
        stateId: buyerAgentDetails?.stateId,
        affiliatedCompany: buyerAgentDetails?.company,
        agentEmailId: buyerAgentDetails?.email,
        agentFirstName: buyerAgentDetails?.firstName,
        agentLastName: buyerAgentDetails?.lastName,
        licenceExpiryDate: formatDisplayDate(
          buyerAgentDetails?.licenseExpiryDate
        ),
        agentLicenseState: buyerAgentDetails?.individualLicenseState,
        tempParam: propertyId,
      };
      const data = await verifyLicense(payload);
      if (data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
        setExternalFormErrors((prev) => ({
          ...prev,
          individualLicenseNumber: "Invalid license format",
        }));
        setLoading(false);
        return { hasError: true };
      } else {
        setExternalFormErrors((prev) => {
          const { individualLicenseNumber, ...rest } = prev;
          return rest;
        });
        setLoading(false);
        return { hasError: false };
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const checkStateCityZip = async () => {
    try {
      const payload = {
        address1: buyerAgentDetails?.address1,
        city: buyerAgentDetails?.city,
        state: buyerAgentDetails?.stateId,
        zip: buyerAgentDetails?.zip,
      };
      const data = await validateAddress(payload);
      if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
        // setInvalidCombination(true);
        setExternalFormErrors((prev) => ({
          ...prev,
          zip: "Provided zip code is not valid for selected state",
        }));
        setHaveErrors(true);
        setLoading(false);
        return { hasError: true };
      } else {
        setExternalFormErrors((prev) => {
          const { zip, ...rest } = prev;
          return rest;
        });
        setLoading(false);
        return { hasError: false };
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    setIsAgent(state?.buyerAgent?.firstName ? "true" : "false");
    setBuyerAgentDetails({
      ...buyerAgentDetails,
      company: (state?.userRole === "BuyerAgent" && (!buyerAgentDetails?.company && !state?.buyerAgent?.company)) 
  ? formState?.companyProfileDto?.brokerageName 
  : (buyerAgentDetails?.company || state?.buyerAgent?.company || ""),
      firstName:
        buyerAgentDetails?.firstName || state?.buyerAgent?.firstName || "",
      lastName:
        buyerAgentDetails?.lastName || state?.buyerAgent?.lastName || "",
      middleInitials:
        buyerAgentDetails?.middleInitials ||
        state?.buyerAgent?.middleInitials ||
        "",
      email: buyerAgentDetails?.email || state?.buyerAgent?.email || "",
      phone: buyerAgentDetails?.phone || state?.buyerAgent?.phone || "",
      address1:
        buyerAgentDetails?.address1 || state?.buyerAgent?.address1 || "",
      address2:
        buyerAgentDetails?.address2 || state?.buyerAgent?.address2 || "",
      stateId: buyerAgentDetails?.stateId || state?.buyerAgent?.stateId || "",
      city: buyerAgentDetails?.city || state?.buyerAgent?.city || "",
      zip: buyerAgentDetails?.zip || state?.buyerAgent?.zip || "",
      corpLicenseState:
        buyerAgentDetails?.corpLicenseState ||
        state?.buyerAgent?.corpLicenseState ||
        "",
      corpLicenseNumber:
        buyerAgentDetails?.corpLicenseNumber ||
        state?.buyerAgent?.corpLicenseNumber ||
        "",
      individualLicenseState:
        state?.state ||
        state?.buyerAgent?.individualLicenseState ||
        "",
      individualLicenseNumber:
        buyerAgentDetails?.individualLicenseNumber ||
        state?.buyerAgent?.individualLicenseNumber ||
        "",
      licenseExpiryDate:
        buyerAgentDetails?.licenseExpiryDate ||
        convertToUIDate(state?.buyerAgent?.licenseExpiryDate) ||
        "",
    });
  }, [state?.buyerAgent]);

  const submitData = async () => {
    if (isAgent === "true") {
      if (validationFnRef.current) {
        const { isValid, data, errors } = validationFnRef.current();
        const corpState = data?.corpLicenseState?.trim();
        const corpNumber = data?.corpLicenseNumber?.trim();

        const isCorpStateFilled = !!corpState;
        const isCorpNumberFilled = !!corpNumber;

        if (
          (isCorpStateFilled && !isCorpNumberFilled) ||
          (!isCorpStateFilled && isCorpNumberFilled)
        ) {
          setError({
            ...errors,
            corporateLicenseState:
              "You can skip entering the corp license state and number or provide both",
          });
          return;
        }

        if (!isValid) return;
        if (isValid) {
          setLoading(true);
          const add = await checkStateCityZip();
          if (add?.hasError) {
            return;
          }
          const licenseVerificationResult = await licenseVerification();
          if (licenseVerificationResult?.hasError) {
            return;
          }

          setError({});
          setEditCifData({
            ...editCifData,
            buyerAgent: {...buyerAgentDetails, licenseExpiryDate: formatDisplayDate(
          buyerAgentDetails?.licenseExpiryDate
        ),},
          });
        }
      }
    } else {
      setError({});
      setEditCifData({
        ...editCifData,
      buyerAgent: {
      company:"",
      firstName:"",
      lastName: "",
      middleInitials:"",
      email:"",
      phone:  "",
      address1:"",
      address2: "",
      stateId: "",
      city: "",
      zip:  "",
      corpLicenseState:"",
      corpLicenseNumber:"",
      individualLicenseState:"",
      individualLicenseNumber:"",
      licenseExpiryDate:"",
        },
      });
    }

    const findNextAccordion = () => {
      setAccordionState({
        ...accordionState,
        accordion2: {
          ...accordionState.accordion2,
          close: true,
          visited: true,
          edit: true,
        },
        accordion3: {
          ...accordionState.accordion3,
          close: false,
        },
      });
    };

    findNextAccordion();
  };

  return (
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header p-1" id="flush-headingThree">
        <div
          className={`accordion-button ${
            accordionState?.accordion2?.close ? "collapsed" : ""
          }  ${
            accordionState?.accordion2?.close &&
            accordionState?.accordion2?.visited
              ? "no-caret"
              : ""
          }`}
          id="acc2"
          disabled={accordionState?.accordion2?.close}
        >
          <div className="d-flex justify-content-between w-100">
            <p className="mb-0">
              {accordionState?.accordion2?.visited ? (
                <BsCheckCircleFill className="icon_bid me-2" size={30} />
              ) : (
                <BsCheckCircleFill className="text-dark me-2" size={30} />
              )}
              Buyer's Agent
            </p>
            {accordionState?.accordion2?.edit && (
              <>
                <div>
                  <span
                    className="fa fa-pencil cursor-pointer"
                    onClick={() => {
                      setAccordionState({
                        ...accordionState,
                        accordion1: {
                          ...accordionState.accordion1,
                          close: true,
                          visited: true,
                          edit: true,
                        },
                        accordion2: {
                          ...accordionState.accordion2,
                          edit: false,
                          close: false,
                          visited: false,
                        },
                        accordion3: {
                          ...accordionState.accordion3,
                          close: true,
                          visited: true,
                          edit: true,
                        },
                      });
                    }}
                  ></span>
                </div>
              </>
            )}
          </div>
        </div>
      </h2>
      {accordionState?.accordion2?.edit ? (
        <>
          <div className="container pb-2">
            <div className="row">
              <div className="col-6">
                <p className="edit-buyer-data">Buyer's Agent :-</p>
                {isAgent === "true" ? (
                  <>
                    <p className="edit-buyer-data mb-0">
                      {buyerAgentDetails?.firstName}{" "}
                      {buyerAgentDetails?.lastName}
                    </p>
                    <p className="edit-buyer-data">
                      {buyerAgentDetails?.email}
                    </p>
                  </>
                ) : (
                  <>
                    <p className="edit-buyer-data mb-0">NA</p>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          id="flush-collapseThree"
          className={`accordion-collapse collapse ${
            accordionState?.accordion2?.close ? "" : "show"
          }`}
          aria-labelledby="flush-headingThree"
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            {
              (  state?.userRole!== "BuyerAgent") &&

            <div className="purchasefor">
              <p className="mb-0 pt-1 purchase-for-ui">
                Do you have a buyer agent?
              </p>
              <div className="values">
                <div className="form-check form-check-inline fs-12">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="buyerAgent"
                    id="buyerAgent-yes"
                    value="true"
                    checked={isAgent === "true" ? true : false}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="buyerAgent-yes">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline fs-12">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="buyerAgent"
                    id="buyerAgent-no"
                    value="false"
                    onChange={handleChange}
                    checked={isAgent === "false" ? true : false}
                  />
                  <label className="form-check-label" htmlFor="buyerAgent-no">
                    No
                  </label>
                </div>
              </div>
            </div>
            }
            {isAgent === "true" && (
              <div className="buyer-form">
                <DynamicForm
                  fieldsConfig={
                    // editCifData?.userRole === "Agent"
                    //   ? buyerWithAgentRole
                    //   : buyerAgent
                    buyerWithAgentRole
                  }
                  setCifFormDetails={setBuyerAgentDetails}
                  cifFormetails={buyerAgentDetails}
                  // preFilledEmail={
                  //   state?.buyerAgent?.email ? true : false
                  // }
                  setHaveErrors={setHaveErrors}
                  validateAgentEmail={validateEmail}
                  statePrefilled={state?.buyerAgent ? "state" : ""}
                  registerValidationTrigger={(fn) =>
                    (validationFnRef.current = fn)
                  }
                  externalErrors={externalFormErrors}
                  setExternalFormErrors={setExternalFormErrors}
                />
              </div>
            )}
            {error?.corporateLicenseState?.length > 0 && (
              <p className={`error-message-offer `}>
                {error?.corporateLicenseState}
              </p>
            )}

            <button
              type="submit"
              className="continue-button ml10"
              onClick={submitData}
              disabled={loading}
            >
              {loading ? "Continue..." : "Continue"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditBuyersAgent;
